(function () {
  'use strict';

  Controller.$inject = [
    'AppUtils',
    'LoopBackAuth',
    '$timeout',
    '$state',
    '$rootScope',
    '$translate',
  ];

  const angular = window.angular;
  angular.module('app').component('heatmapDataDisplay', {
    template:'<div class="panel panel-default rt-panel rt-panel-sm {{ctrl.cssClass}}" ng-if="!ctrl.onlyContent"><header class="panel-heading" ng-if="ctrl.showHeader"><h2><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right" ng-if="ctrl.image" data-html2canvas-ignore><div class="panel-toolbar" ng-if="ctrl.classes.length"><ui-select ng-change="ctrl.calcWeights()" ng-model="ctrl.class" theme="select2" append-to-body="true" ng-class="{\'compact-select2\': true}" search-enabled="false"><ui-select-match allow-clear="true" placeholder="{{::\'general._select.a\' | translate}} {{::\'entities.sensor.class.modelName\' | translate}}">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="class.value as class in ctrl.classes | orderBy: \'label\' | filter: $select.search"><div ng-bind-html="class.label"></div></ui-select-choices></ui-select></div><div class="panel-toolbar"><div class="btn-group" data-toggle="buttons"><label ng-click="ctrl.viewMode = \'image\'" ng-class="{active: ctrl.viewMode === \'image\'}" class="btn btn-default btn-xs" title="Image"><input type="radio"> <i class="fas fa-image"></i></label> <label ng-click="ctrl.viewMode = \'raw\'" ng-class="{active: ctrl.viewMode === \'raw\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'general.details\'}"><input type="radio"> <i class="fas fa-code"></i></label></div></div></div></header><div class="panel-body" ng-class="{\'with-location\': ctrl.data.location}"><div class="rt-content"><div ng-if="ctrl.content" class="full-height" style="position: relative"><div ng-if="ctrl.viewMode=== \'image\'" ng-click="ctrl.expand()"><background-image ng-if="ctrl.imageSrc" image-src="ctrl.imageSrc" on-load-content="ctrl.onLoadImage" image-mode="ctrl.imageMode" dimensions="ctrl.dimensions" max-height="ctrl.maxHeight" disable-spinner="ctrl.disableSpinner"></background-image><heatmap-grid ng-if="ctrl.dimensions.width" dimensions="ctrl.dimensions" grid-size="ctrl.gridSize" disable-slider="true" weights="ctrl.weights"></heatmap-grid></div><div ng-if="ctrl.viewMode=== \'raw\'"><pre>{{ctrl.content | json}}</pre><div class="floating-btn" style="right: 5px" data-html2canvas-ignore><a class="btn btn-default btn-xs" ng-click="ctrl.downloadRawData()"><i class="fas fa-download fa-fw"></i></a></div></div></div><div ng-if="ctrl.data && !ctrl.data.content" class="not-data-found"><div class="small" translate>errors.NOT_DATA_FOUND</div></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div class="rt-footer"><div class="date" ng-if="ctrl.content">{{ctrl.data.from | date: "yyyy-MM-dd HH:mm:ss"}}<div ng-if="ctrl.data.location"><a target="_blank" ng-href="https://www.google.com/maps/search/?api=1&query={{ctrl.data.location.coordinates[1]}},{{ctrl.data.location.coordinates[0]}}">[ {{ctrl.data.location.coordinates[1]}}, {{ctrl.data.location.coordinates[0]}} ]</a></div></div></div></div></div><div ng-if="ctrl.onlyContent" class="rt-content" style="top: 0; bottom: 0; right: 0; left: 0"><div ng-if="ctrl.content"><div ng-if="ctrl.viewMode=== \'image\'"><background-image ng-if="ctrl.imageSrc" image-src="ctrl.imageSrc" on-load-content="ctrl.onLoadImage" image-mode="ctrl.imageMode" dimensions="ctrl.dimensions" max-height="ctrl.maxHeight" disable-spinner="ctrl.disableSpinner"></background-image><heatmap-grid ng-if="ctrl.dimensions.width" dimensions="ctrl.dimensions" grid-size="ctrl.gridSize" disable-slider="true" weights="ctrl.weights"></heatmap-grid></div><div ng-if="ctrl.viewMode=== \'raw\'"><pre>{{ctrl.content | json}}</pre><div class="floating-btn" style="right: 5px" data-html2canvas-ignore><a class="btn btn-default btn-xs" ng-click="ctrl.downloadRawData()"><i class="fas fa-download fa-fw"></i></a></div></div></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div ng-if="ctrl.extendView" draggable class="floating-container floating-div"><div class="panel panel-default rt-panel rt-panel-md"><div class="panel-heading"><h2><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><i class="fas fa-fw fa-times" ng-click="ctrl.extendView = !ctrl.extendView"></i></div></div></div><div class="panel-body"><detection-image filter-by-zone="ctrl.filterByZone" sensor="ctrl.sensor" data="ctrl.data" feedback="ctrl.feedback" zone="ctrl.zone" copy-objects="ctrl.copyObjects" max-height="ctrl.newImgWidth" disable-click="ctrl.disableClick" on-load-content="ctrl.onloadOverlay"></detection-image><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div></div></div>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      assetName: '<',
      asset: '<',
      state: '<',
      data: '<',
      onlyContent: '<',
      onLoadContent: '<',
      showHeader: '<',
      disableClick: '<',
    },
  });

  function Controller(utils, LoopBackAuth, $timeout, $state, $root, $translate) {
    const vm = this;
    let firstChange = true;

    vm.dimensions = {};
    vm.class = null;

    vm.$onInit = () => {
      vm.viewMode = 'image';
      vm.expand = expand;
      vm.showHeader = typeof vm.showHeader === 'boolean' ? vm.showHeader : true;
      vm.onLoadImage = onLoadImage;
      vm.calcWeights = calcWeights;

      firstChange = false;
      init();

      vm.state = $state.get().reduce((filtered, current) => {
        const name = current.name;
        const component = current.component;
        if (name.includes('dataDisplay') && component === 'monitoringDataDisplay') {
          filtered.push(current);
        }
        return filtered;
      }, [])[0];
    };

    vm.$onChanges = function (changes) {
      if (firstChange) {
        return;
      }

      init();
    };

    function expand() {
      if (vm.disableClick) {
        return;
      }

      const dataId = vm.data.referenceId || vm.data.id;

      window.open(
        $state.href(
          vm.state,
          {
            projectId: $root.projectId,
            assetId: vm.sensor.assetId,
            sensorId: vm.sensor.id,
            dataId: utils.isDate(dataId) ? dataId.getTime() : dataId,
          },
          '_blank'
        )
      );
    }

    function init() {
      $timeout(() => {
        const file = vm.asset?.container?._background;

        vm.imageSrc = file
          ? utils.getEntityFileUrl(
              'Asset',
              vm.asset.id,
              'background',
              file,
              LoopBackAuth.accessTokenId
            )
          : null;

        vm.content = vm.data?.content;
        vm.gridSize = vm.content?.gridSize || 10;

        vm.classes = getClasses();
        calcWeights();
      });
    }

    function getClasses() {
      if (!vm.content || !vm.content.heatmap) {
        return [];
      }

      const classes = new Set();
      for (const el of vm.content.heatmap || []) {
        for (const [className, count] of Object.entries(el.counts || {})) {
          if (count > 0) {
            classes.add(className);
          }
        }
      }

      if (vm.class && !classes.has(vm.class)) {
        vm.class = null;
      }

      return Array.from(classes)
        .map((c) => {
          return {
            value: c,
            label: $translate.instant(`entities.sensor.__classes.${c}`),
          };
        })
        .sort((a, b) => {
          return a.label.localeCompare(b.label);
        });
    }

    function calcWeights() {
      vm.weights = {};

      if (!vm.content || !vm.content.heatmap) {
        return;
      }

      for (const el of vm.content.heatmap || []) {
        const x = el.x;
        const y = el.y;

        if (!vm.weights[x]) {
          vm.weights[x] = {};
        }

        if (!vm.weights[x][y]) {
          vm.weights[x][y] = 0;
        }

        if (vm.class) {
          vm.weights[x][y] = el.counts[vm.class] || 0;
        } else {
          vm.weights[x][y] = Object.keys(el.counts || {}).reduce((acc, key) => {
            return acc + (el.counts[key] || 0);
          }, 0);
        }
      }
    }

    function onLoadImage(err, image) {
      vm.image = image;
      vm.viewMode = image ? 'image' : 'raw';
      if (vm.onLoadContent) {
        vm.onLoadContent(err, image);
      }
    }
  }
})();
